export default __webpack_public_path__ + "static/media/myimg1.96de9bb2.jpg";